import React from "react";
import CompanyView from "../CompanyView";
import EmployeeList from "../../Employees/EmployeeList";
import { ProfileTabConfig } from "../../Profile/types/profileTypes";
import { Card } from "@mui/material";
import SubscriptionLink from "../SubscriptionLink";

export const CompanyTabsConfig: ProfileTabConfig[] = [
  {
    id: 0,
    labelKey: "company-tab",
    defaultLabel: "Details",
    ariaControls: "company-tabpanel-0",
    content: <CompanyView />
  },
  {
    id: 1,
    labelKey: "employee-tab",
    defaultLabel: "Employees",
    ariaControls: "employees-tabpanel-1",
    content: (
      <Card
        sx={{
          borderRadius: 3,
          p: { xs: 2, sm: 3 },
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
        }}
      >
        <EmployeeList />{" "}
      </Card>
    )
  },
  {
    id: 2,
    labelKey: "company-subscriptions-tab",
    defaultLabel: "Subscriptions",
    ariaControls: "subscriptions-tabpanel-2",
    content: (
      <Card
        sx={{
          borderRadius: 3,
          p: { xs: 2, sm: 3 },
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
        }}
      >
        <SubscriptionLink />
      </Card>
    )
  }
];
